module.exports = __webpack_public_path__ + "media/images/common/lp/bg-ctaBox--right-dd02ab552a8d4cd620cdbda650193a58.png";